import doctor1 from "../images/Admin/Doctor1.png";
import doctor2 from "../images/Admin/Doctor2.png";
import doctor3 from "../images/Admin/Doctor3.png";
import doctor4 from "../images/Admin/Doctor4.png";
export const doctors = [
  {
    name: "Gavhar",
    surname: "Sobirova",
    profession: "Nevropatolog",
    img: doctor1,
  },
  {
    name: "Bahrom",
    surname: "Abdullayev",
    profession: "Nevropatolog",
    img: doctor2,
  },
  {
    name: "Baxtiyor",
    surname: "Sodiqov",
    profession: "Nevropatolog",
    img: doctor4,
  },
  {
    name: "Sanjar",
    surname: "Tohirov",
    profession: "Nevropatolog",
    img: doctor3,
  },
];
